// Small, conservative English stopword list. Terms here never count toward a
// job's keyword weight and are ignored when matching. Kept intentionally short:
// over-filtering would hide real skill gaps.
export const STOPWORDS = new Set<string>([
  'a', 'an', 'and', 'are', 'as', 'at', 'be', 'been', 'being', 'but', 'by',
  'can', 'could', 'did', 'do', 'does', 'for', 'from', 'had', 'has', 'have',
  'he', 'her', 'him', 'his', 'how', 'i', 'if', 'in', 'into', 'is', 'it',
  'its', 'me', 'must', 'my', 'no', 'not', 'of', 'on', 'or', 'our', 'she',
  'should', 'so', 'than', 'that', 'the', 'their', 'them', 'then', 'there',
  'these', 'they', 'this', 'those', 'to', 'was', 'we', 'were', 'what', 'when',
  'where', 'which', 'while', 'who', 'whom', 'why', 'will', 'with', 'would',
  'you', 'your', 'year', 'years', 'work', 'working', 'role', 'job', 'team',
  'teams', 'ability', 'abilities', 'experience', 'experienced', 'skill',
  'skills', 'requirement', 'requirements', 'responsibility', 'responsibilities',
  'qualification', 'qualifications', 'plus', 'strong', 'good', 'great',
  'excellent', 'proven', 'minimum', 'preferred', 'knowledgable',
  'knowledgeable', 'familiar', 'familiarity', 'understanding', 'understand',
  'looking', 'join', 'help', 'using', 'use', 'used', 'across', 'within',
  'among', 'etc', 'e.g', 'ie', 'will be', 'the ideal', 'opportunity',
]);
